export default({
	// state: {
	// 	WX_STATE: 0,
	// 	USER_ID: '',
	// 	SELLER_ID: '',
	// 	I_SHOP: '',
	// 	HEAD_IMG: '',
	// 	USER_NAME: '',
	// 	ROOT_URL: '//www.zlqt.zlqthb.com/', //测试
	// 	IMG_URL: '//img.zlqthb.com', //图片
	// 	BASE_URL: '//www.zlqt.zlqthb.com', //
	// 	USER_URL: '//www.zlqt.zlqthb.com/',
	// 	HIMG_URL: '//www.zlqt.zlqthb.com/'
	// },
	state: {
		WX_STATE: 0,
		USER_ID: '',
		SELLER_ID: '',
		I_SHOP: '',
		HEAD_IMG: '',
		USER_NAME: '',
		ROOT_URL: '//www.hbchanyelian.com/',
		IMG_URL: '//img.hbchanyelian.com/',
		BASE_URL: '//www.hbchanyelian.com/',
		USER_URL: '//www.hbchanyelian.com/',
		HIMG_URL:'//himg.chinaxdsb.com/'
	},
	
	
})



// WEBPACK FOOTER //
// ./src/store/index.js